import http from '@/utils/http';

import type { IRobloxGameRankFetchParams } from '../pages/RobloxGameRank/utils/buildRobloxGameRankFetchParams';
import type { IRobloxGameRankRow } from '../pages/RobloxGameRank/types';
import {
  getRobloxResolvedDateRangeFromReq,
  parseRobloxApiRequestMeta,
} from '../utils/robloxFilterDate';

import type { IRobloxResolvedDateRange } from '../utils/robloxFilterDate';

export const fetchRobloxGameRanks = (
  data: IRobloxGameRankFetchParams,
  options?: { signal?: AbortSignal },
): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/game/roblox/ranks',
    method: 'post',
    data,
    rawData: true,
    signal: options?.signal,
  }) as Promise<any>;
};

const mergeRobloxGameRankRow = (
  item: Record<string, any>,
  entityInfoMap: Record<string, Record<string, any>>,
): IRobloxGameRankRow => {
  const gameId = item?.game_id;
  const entityInfo = gameId ? entityInfoMap[gameId] : undefined;

  return {
    ...item,
    ...(entityInfo || {}),
    entity_info: entityInfo,
  };
};

export const parseRobloxGameRankResponse = (
  response: any,
): {
  list: IRobloxGameRankRow[];
  total: number;
  resolvedDateRange: IRobloxResolvedDateRange | null;
} => {
  const payload = response?.data ?? response ?? {};
  const entityInfoMap = response?.ext?.entity_info ?? {};
  const rawList = Array.isArray(payload?.list) ? payload.list : [];
  const resolvedDateRange = getRobloxResolvedDateRangeFromReq(
    parseRobloxApiRequestMeta(response),
  );

  return {
    list: rawList.map((item: Record<string, any>) =>
      mergeRobloxGameRankRow(item, entityInfoMap),
    ),
    total: Number(payload?.total) || 0,
    resolvedDateRange,
  };
};
